import { AxiosInstance } from 'axios';
import { ChildClassesRepository } from '@/model/repository/shift/ChildClassesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ChildClassesRepository => ({
    index() {
      return Repository.get(`${resource}`);
    },
  });
